import React from "react";
import "./Footer.scss"
import visa from "../../assets/visa.svg"
import master from "../../assets/master.svg"
import amex from "../../assets/amex.svg"
import paypal from "../../assets/paypal.svg"
import fb from "../../assets/fb.svg"
import twitter from "../../assets/twitter.svg"
import linkedIn from "../../assets/linkedIn.svg"
import insta from "../../assets/insta.svg"



const Footer = () => {
    const footerContet = [
        {
            "header": "Products",
            "content": ["Payment Processing", "Business Accounts", "Multi-Currency",
                "Analytics", "Invoicing"
            ]
        },
        {
            "header": "Company",
            "content": ["About Us", "Careers", "Press",
                "Partners", "Contact"
            ]
        }, {
            "header": "Resources",
            "content": ["Help Center", "Documentation", "API Reference",
                "Blog", "Community"
            ]
        },
    ]
    return (
        <div className="WitEarnFooter">
            <div className="WitEarnFooter-top">
                <div className="WitEarnFooter-top-grid-item">
                    <div className="WitEarnFooter-header-logo">
                        <div className="WitEarnFooter-header-logo-lg">W</div>
                        WitEarn
                    </div>
                    <div className="WitEarnFooter-contnt">
                        The all-in-one payment solution for modern businesses. Accept payments, manage finances, and grow your business with WitEarn.
                    </div>
                    <div className="WitEarnFooter-img-cont">
                        <img alt="" src={fb} />
                        <img alt="" src={twitter} />
                        <img alt="" src={linkedIn} />
                        <img alt="" src={insta} />
                    </div>
                </div>
                {footerContet.map((content, key) => {
                    return (
                        <div className="WitEarnFooter-top-grid-item" key={key}>
                            <div className="WitEarnFooter-header">
                                {content?.header}
                            </div>
                            {content.content.map((ctn, idx) => {
                                return (<div className="WitEarnFooter-contnt" key={idx}>
                                    {ctn} </div>)
                            })}

                        </div>
                    )
                })}

            </div>
            <div className="WitEarnFooter-bottom">
                <div className="WitEarnFooter-bottom-left">
                    © 2025 WitEarn. All rights reserved.
                </div>
                <div className="WitEarnFooter-bottom-right">
                    <div className="WitEarnFooter-bottom-right-items">
                        Terms
                    </div>
                    <div className="WitEarnFooter-bottom-right-items">
                        Privacy
                    </div>
                    <div className="WitEarnFooter-bottom-right-items">
                        Cookies
                    </div>
                    <div className="WitEarnFooter-bottom-right-cards">
                        <img alt="" src={visa} />
                        <img alt="" src={master} />
                        <img alt="" src={amex} />
                        <img alt="" src={paypal} />

                    </div>
                </div>
            </div>
        </div>
    )
}
export default Footer